import {
  ShieldCheck,
  UserCheck,
  AlertOctagon,
  MailMinus,
} from 'lucide-react';
import { siteData } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

const iconMap = {
  ShieldCheck,
  UserCheck,
  AlertOctagon,
  MailMinus,
};

export const BookingSection = () => {
  const { booking } = siteData;
  const [ref, isInView] = useInView();

  return (
    <section id="how-it-works" className="py-[90px] lg:py-[110px] bg-white">
      <div
        ref={ref}
        className={`max-w-[1200px] mx-auto px-6 lg:px-8 ${
          isInView ? 'animate-fade-in-up' : 'opacity-0'
        }`}
      >
        <div className="max-w-[680px] mb-10">
          <h2 className="font-heading text-[1.85rem] lg:text-[2.5rem] font-bold text-stone-900 leading-[1.15] tracking-[-0.01em]">
            {booking.headline}
          </h2>

          <p className="mt-5 text-[1.05rem] text-stone-500 leading-[1.7]">
            {booking.intro}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {booking.points.map((point, index) => {
            const Icon = iconMap[point.icon];
            return (
              <div
                key={index}
                className="flex items-start gap-3.5 p-5 rounded-2xl bg-[#faf9f6] border border-stone-100 hover:border-[#2d6a5a]/12 hover:shadow-[0_2px_8px_rgba(0,0,0,0.03)]"
                style={{ transition: 'border-color 0.3s, box-shadow 0.3s' }}
              >
                <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-[#2d6a5a]/8 flex items-center justify-center mt-0.5">
                  {Icon && <Icon size={16} className="text-[#2d6a5a]" />}
                </div>
                <p className="text-stone-600 text-[0.9rem] leading-relaxed pt-1">
                  {point.text}
                </p>
              </div>
            );
          })}
        </div>

        <p className="mt-9 text-[0.85rem] text-[#2d6a5a] font-medium tracking-wide">
          {booking.trust}
        </p>
      </div>
    </section>
  );
};
